import React, {useContext} from 'react';
import {Row, Col, Select, Button, Tooltip, Tag, Typography, Popconfirm, Space} from 'antd';
import {RollbackOutlined} from '@ant-design/icons';
import {CommitDetailsDialog} from './commit-details-dialog';
import semverParse from 'semver/functions/parse';
import {OpenApiContext} from '../openapi-context';

function PreReleaseTag({version}) {
    if (version) {
        const info = semverParse(version);
        return info.prerelease.length > 0 && <Tag color="volcano">{info.prerelease[0]}</Tag>;
    } else {
        return null;
    }
}

export function VersionPanel({changeVersion, version, dirty, versions, onCommit, onRollback, mobile}) {
    const {state} = useContext(OpenApiContext);
    const specVersion = typeof state.info === 'function' ? state.info()?.version : undefined;
    const latestLabel = specVersion ? `v${specVersion} (workspace)` : '(Latest Version)';

    return (
        <Row className="panel">
            <Col xs={dirty ? 18 : 24}>
                <Select disabled={state.editMode} value={version} style={mobile ? {width: '100%', marginLeft: 10} : {width: '100%'}} placeholder="Pick a version here" onChange={changeVersion}>
                    <Select.Option value="latest"> {latestLabel} {dirty && version === 'latest' && <span>*</span>}</Select.Option>
                    {versions &&
                        versions.map((v) => (
                            <Select.Option key={v} value={v}>
                                {v} <PreReleaseTag version={v} /> {dirty && v == version && <Typography.Text type="danger">*</Typography.Text>}
                            </Select.Option>
                        ))}
                </Select>
            </Col>
            {dirty && (
                <Col xs={6}>
                    <Space>
                        <CommitDetailsDialog version={version} onCommit={onCommit} versions={versions} />
                        <Popconfirm placement="bottom" title="Sure to revert?" okType="default" onConfirm={onRollback}>
                            <Tooltip placement="bottom" title="Revert to previous version. Ignoring current changes">
                                <Button className="revertButton" type="danger" icon={<RollbackOutlined />} />
                            </Tooltip>
                        </Popconfirm>
                    </Space>
                </Col>
            )}
        </Row>
    );
}
